import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Activity14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.73214 2.83732L7.14475 9.19406L8.78849 4.26284C9.00183 3.62282 9.9236 3.58448 10.1894 4.20457L11.4296 7.09849C11.469 7.19041 11.5594 7.25001 11.6594 7.25001H14V8.75001H11.6594C10.9593 8.75001 10.3267 8.33282 10.0509 7.68937L9.58771 6.6086L7.71151 12.2372C7.47675 12.9415 6.42891 12.8874 6.26786 12.1627L4.79459 5.53298L3.9478 7.64995C3.68204 8.31435 3.03855 8.75001 2.32297 8.75001H0V7.25001H2.32297C2.42519 7.25001 2.51712 7.18778 2.55509 7.09286L4.30364 2.72147C4.57125 2.05245 5.57583 2.13392 5.73214 2.83732Z'
      fill='currentColor'
    />
  </Svg>
);

Activity14.displayName = 'Activity14';
export default Activity14;
